import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import type { HomeCuentaPerfil } from '../components/home-cuenta/home-cuenta.component';
import type {
  HomeCuentaCampaniaExtrasJuridica,
  HomeCuentaCampaniaExtrasNatural,
} from '../utils/home-cuenta-campania.mapper';

export interface HomeCuentaCampaniaParams {
  perfil: HomeCuentaPerfil;
  idCampania: string;
  token: string;
}

/**
 * Params de campaña leídos una vez desde `/home?perfil&id&token`.
 * Los forms consumen el snapshot al montar / cuando hay match de perfil.
 * Los extras (genero, depto, ciiu, etc.) se conservan hasta el submit del registro.
 */
@Injectable({ providedIn: 'root' })
export class HomeCuentaCampaniaService {
  private readonly paramsSubject =
    new BehaviorSubject<HomeCuentaCampaniaParams | null>(null);

  private extrasNatural: HomeCuentaCampaniaExtrasNatural | null = null;
  private extrasJuridica: HomeCuentaCampaniaExtrasJuridica | null = null;

  readonly params$: Observable<HomeCuentaCampaniaParams | null> =
    this.paramsSubject.asObservable();

  setParams(params: HomeCuentaCampaniaParams | null): void {
    this.paramsSubject.next(params);
  }

  peek(): HomeCuentaCampaniaParams | null {
    return this.paramsSubject.value;
  }

  /** Limpia solo id/token de URL; no borra extras de precarga. */
  clear(): void {
    this.paramsSubject.next(null);
  }

  setExtrasNatural(extras: HomeCuentaCampaniaExtrasNatural | null): void {
    this.extrasNatural = extras;
    this.extrasJuridica = null;
  }

  setExtrasJuridica(extras: HomeCuentaCampaniaExtrasJuridica | null): void {
    this.extrasJuridica = extras;
    this.extrasNatural = null;
  }

  peekExtrasNatural(): HomeCuentaCampaniaExtrasNatural | null {
    return this.extrasNatural;
  }

  peekExtrasJuridica(): HomeCuentaCampaniaExtrasJuridica | null {
    return this.extrasJuridica;
  }

  clearExtras(): void {
    this.extrasNatural = null;
    this.extrasJuridica = null;
  }
}
